// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1ikCc","info":"PatientInfo_info__2_mng"};